module.exports = __webpack_public_path__ + "static/media/sayabout-user3.a911249f.jpg";